export const FEATURE_FLAGS = Object.freeze({
    ENABLE_EMAIL_FROM_RAVEN: 'enable-email-from-RAVEN',
    ENABLE_SENSE_ACCESS: 'enable-sense-access',
    ENABLE_SELF_ENROLMENT: 'enable-self-enrolment',
    ENABLE_ADVANCED_SSO_ACCOUNT_CENTER: 'enable-advanced-sso-account-center',
});

export const CLIENT_FEATURE_FLAGS = [
    FEATURE_FLAGS.ENABLE_EMAIL_FROM_RAVEN,
    FEATURE_FLAGS.ENABLE_SENSE_ACCESS,
    FEATURE_FLAGS.ENABLE_SELF_ENROLMENT,
    FEATURE_FLAGS.ENABLE_ADVANCED_SSO_ACCOUNT_CENTER,
];
